import React from 'react';
import { useAppConfig } from '../hooks';

export const ConfigLoader: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { error, isLoading } = useAppConfig();

    if (error) {
        throw error;
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return <>{children}</>;
};
